/**
 * Component: Markdown variant visibility
 * -----------------------------------------------------------------------------
 * Shows or hides rich text blocks based on the selected variant's
 * custom.sale metafield.
 *
 * Liquid renders the correct first state. This script updates it when the
 * shopper changes size or color, including high-variant products whose sale
 * metafield is loaded through the variant picker.
 *
 * ## Attributes:
 *  - data-markdown-visibility="markdown_only"       — show only for Markdown SKUs
 *  - data-markdown-visibility="hide_when_markdown"  — hide for Markdown SKUs
 *
 * ## Events consumed:
 *  - on:variant:change
 *
 * Liquid only outputs these attributes when the rich text block enables
 * marked-down messages and the product department matches that block.
 */

(() => {
  const BLOCK_SELECTOR = '[data-markdown-visibility]';

  if (!document.querySelector(BLOCK_SELECTOR)) {
    return;
  }

  /**
   * Whether the selected variant is a marked-down SKU.
   * @param {HTMLElement | null} productRoot
   * @param {{ id?: number, sale?: string } | null | undefined} variant
   * @returns {boolean}
   */
  function isMarkdownVariant(productRoot, variant) {
    if (!productRoot || !variant?.id) {
      return false;
    }

    const picker = productRoot.querySelector('variant-picker');
    const formattedSale = picker?.data?.formatted?.[variant.id]?.variantSale;
    const variantSale = formattedSale || variant.sale || '';

    return variantSale === 'Markdown';
  }

  /**
   * Applies Final Sale / returns visibility for the current variant.
   * @param {HTMLElement} productRoot
   * @param {{ id?: number, sale?: string } | null | undefined} variant
   */
  function updateBlocks(productRoot, variant) {
    const isMarkdown = isMarkdownVariant(productRoot, variant);

    productRoot.querySelectorAll(BLOCK_SELECTOR).forEach((block) => {
      const mode = block.getAttribute('data-markdown-visibility');
      let shouldHide = false;

      if (mode === 'markdown_only') {
        shouldHide = !isMarkdown;
      } else if (mode === 'hide_when_markdown') {
        shouldHide = isMarkdown;
      }

      block.hidden = shouldHide;
    });
  }

  document.addEventListener('on:variant:change', (event) => {
    const productRoot = event.target?.closest?.('.js-product');

    if (!productRoot?.querySelector(BLOCK_SELECTOR)) {
      return;
    }

    updateBlocks(productRoot, event.detail?.variant);
  });
})();
